import { render } from "./OrderItem.vue?vue&type=template&id=3d242ab2&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=3d242ab2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d242ab2"

export default script